<!--
  TeCopyPopoverComponent Template
  ===============================
  Context-aware popover with copy-to-clipboard options for FreeMarker
  variable expressions, loops, and conditionals.
  The popover stays open after copying; each item flashes green on copy.
-->

<p-popover #copyPopover>
  <div class="te-copy-popover">

    <!-- Header showing label and path -->
    @if (attrData) {
      <div class="te-copy-header">{{ attrData.label }} — {{ attrData.path }}</div>
    }

    <!-- Copy items list -->
    @for (item of copyItems; track $index) {

      <!-- Separator -->
      @if (item.separator) {
        <div class="te-copy-separator"></div>
      }

      <!-- Section Header -->
      @if (item.header) {
        <div class="te-copy-section-header">{{ item.header }}</div>
      }

      <!-- Copy Item -->
      @if (!item.separator && !item.header) {
        <div class="te-copy-item"
             [class.flash-green]="item.flashActive"
             (click)="copyToClipboard(item)">
          <span class="te-copy-icon">
            <i [class]="item.icon"></i>
          </span>
          <span class="te-copy-label">{{ item.label }}</span>
          <span class="te-copy-code">{{ item.codePreview }}</span>
        </div>
      }

    }

  </div>
</p-popover>
